<div class="health-bar-wrapper">
    <div id="health-bar" data-total="1000" [attr.data-value]="health">
        <div id="bar">
            <div id="hit"></div>
        </div>
    </div>
</div>

